function getQueryVariable(variable: string) {
  const query = window.location.href.split('?')[1]
  const vars = query.split('&')
  let result = ''
  vars.forEach((cvar: string) => {
    const pair = cvar.split('=')
    if (decodeURIComponent(pair[0]) === variable) {
      result = decodeURIComponent(pair[1])
    }
  })
  return result
}

export default getQueryVariable